import React from 'react';
import { Bubble } from 'tea-component';
import './index.scss';
import { useIntl } from 'umi';
import useGenresIntl from '@intelligence/hooks/useGenresIntl';

import type { IGenreSource } from '@intelligence/types/common';

interface GENRE {
  genreSource?: IGenreSource;
  mainGenre: string;
  subGenre: string;
}
export default function TableGenre(props: GENRE) {
  const {
    genreSource: genreSourceValue = 'iegg',
    mainGenre: mainGenreValue = '-',
    subGenre: subGenreValue = '-',
  } = props;
  // console.debug('genreSourceValue', genreSourceValue, mainGenreValue, subGenreValue);
  const { formatMessage } = useIntl(); // 中英切换方法
  const genresDataFormatMessage = useGenresIntl();
  const { mainGenre, subGenre } = genresDataFormatMessage({
    genreSource: genreSourceValue,
    mainGenre: mainGenreValue,
    subGenre: subGenreValue,
  });

  const showText = () => {
    return (
      <>
        <Bubble arrowPointAtCenter placement="top" content={isShowBubble()} closeOnScroll={true} dark>
          <p className="main_genre">
            <span>
              {formatMessage({ id: `dbi_genre_main` })} : {mainGenre}
            </span>
          </p>
          <p className="sub_genre">
            <span>
              {formatMessage({ id: `dbi_genre_sub` })} : {subGenre}
            </span>
          </p>
        </Bubble>
      </>
    );
  };

  const isShowBubble = () => {
    return (
      <>
        <p className="main_genre_general" style={{ lineHeight: 1 }}>
          <span>
            {formatMessage({ id: `dbi_genre_main` })} : {mainGenre?.replaceAll(',', ', ')?.replaceAll('|', ' | ')}
          </span>
        </p>
        <p className="sub_genre_general">
          <span>
            {formatMessage({ id: `dbi_genre_sub` })}  : {subGenre?.replaceAll(',', ', ')?.replaceAll('|', ' | ')}
          </span>
        </p>
      </>
    );
  };

  return (
    <div className="general_table_genre">
      {(mainGenre === '-' && subGenre === '-') || genreSourceValue === 'weixin' ? isShowBubble() : showText()}
    </div>
  );
}
